import React from 'react';
import { Helmet } from 'react-helmet-async';

const sanitizeData = (data) => {
  if (!data) {
    return [];
  }

  const items = Array.isArray(data) ? data : [data];
  return items.filter((item) => item && typeof item === 'object' && !Array.isArray(item));
};

const StructuredData = ({ data }) => {
  const items = sanitizeData(data);
  if (items.length === 0) {
    return null;
  }

  return (
    <Helmet>
      {items.map((item, index) => (
        <script key={`structured-data-${index}`} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
};

export default StructuredData;
